import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Store, Types, AppFields, AlertContent, Observable } from '../../store'

@Component({
  selector: 'app-snackbar-com',
  templateUrl: 'snackbar.com.html',
  styleUrls: ['snackbar.com.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SnackbarComponent implements OnInit {

  alert: Observable<AlertContent>

  constructor(private store: Store<any>) {
    this.alert = this.store.select(AppFields.App, AppFields.Alert).map(a => a ? a : new AlertContent())
  }

  ngOnInit() {
    this.alert.subscribe((alert: AlertContent) => {
      if (alert.showSnackbar) {
        setTimeout(() => this.store.dispatch({
          type: Types.UpdateState,
          payload: { alert: new AlertContent() }
        }), 3000);
      }
    })
  }

  public close() {
    setTimeout(() => this.store.dispatch({
      type: Types.UpdateState,
      payload: { alert: new AlertContent() }
    }), 1000)
  }

}



// WEBPACK FOOTER //
// ./src/app/com/snackbar/snackbar.com.ts